import maintenanceImg from '../../assets/img/Illustration.svg';
import maintenancelogo from '../../../src/assets/img/darklogo.svg';

const MaintenancePage = () => {
  return (
    <>
      <div id="crm-maintenance">
        <div className="maintenance-wrapper">
          <div className="maintenance-container">
            <div className="maintenance-header">
              <img src={maintenancelogo} alt="logo" className="maintenance-logo" />
            </div>

            <div className="maintenance-content">
              <div className="maintenance-left">
                <h1>Application Under Maintenance</h1>
                <p>We're improving your experience! Please check back shortly.</p>
              </div>
              <div className="maintenance-right">
                <img src={maintenanceImg} alt="Maintenance" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MaintenancePage;
